<template>
  <div class="customer">
    <div class="queryBox">
      <el-form
        :inline="true"
        :model="formData"
        class="demo-form-inline"
        ref="form"
      >
        <el-form-item
          label="模块"
          prop="service_type"
        >
          <el-select
            v-model="formData.service_type"
            placeholder="模块"
            @visible-change="e=>getScreen(e,'module_type')"
          >
            <el-option
              v-for="(item,index) in typeList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="店铺"
          prop="bid"
        >
          <el-select
            v-model="formData.bid"
            placeholder="店铺"
            @visible-change="e=>getScreen(e,'business')"
          >
            <el-option
              v-for="(item,index) in bidList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="促销员"
          prop="refer_id"
        >
          <el-select
            v-model="formData.refer_id"
            placeholder="促销员"
            @visible-change="e=>getScreen(e,'promoter')"
          >
            <el-option
              v-for="(item,index) in promoterList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="value2"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            align="right"
            value-format="timestamp"
            @change="timeChange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
          >查询</el-button>
          <el-button @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="chartBox">
      <div class="left">
        <div class="surveyBox publicCss">
          <div class="surveyTitle">订单概况</div>
          <div class="surveyInfo">
            <div class="totalBox">
              <div class="totalIcon">
                <img
                  src="@/assets/images/orderSalesVolume.png"
                  alt=""
                >
              </div>
              <div class="totalDetail">
                <div class="TD_title">销售额</div>
                <div class="TD_num">{{salesSum}}</div>
              </div>
            </div>
            <div class="totalBox">
              <div class="totalIcon">
                <img
                  src="@/assets/images/order_card.png"
                  alt=""
                >
              </div>
              <div class="totalDetail">
                <div class="TD_title">办卡量</div>
                <div class="TD_num">{{cardNum}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="genderBox publicCss">
          <div class="genderTitle">洗车套餐办卡量</div>
          <carCardDialog :cardRatio="cardRatio"></carCardDialog>
        </div>
      </div>
      <div class="right">
        <div class="totalNum publicCss">
          <div class="totalNum_title">销售额</div>
          <salesVolumeDialog :priceData="price"></salesVolumeDialog>
        </div>
        <div class="newNumBox publicCss">
          <div class="newNum_title">办卡量/洗车量</div>
          <washcarChart
            :saleCard="saleCard"
            :washcar="washcar"
            :douyinCard="douyinCard"
          ></washcarChart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderStatistics } from '@/api/order.js'
import { screenMixins } from '@/mixins/screenMixins'
import carCardDialog from './chart/carCard.vue'
import salesVolumeDialog from './chart/salesVolume.vue'
import washcarChart from './chart/washcar.vue'
export default {
  mixins: [screenMixins],
  components: { carCardDialog, salesVolumeDialog, washcarChart },
  data () {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      value2: '',
      formData: {
        service_type: '',
        bid: '',
        refer_id: '',
        startTime: '',
        endTime: ''
      },
      salesSum: '',
      cardNum: '',
      saleCard: [],
      douyinCard: [],
      cardRatio: {},
      price: [],
      washcar: []
    }
  },
  mounted () {
    this.getInfo()
  },
  methods: {
    async getInfo () {
      try {
        this.price = []
        this.saleCard = []
        this.washcar = []
        this.douyinCard = []
        const _response = await orderStatistics(this.formData)
        const { error, data, msg } = _response
        if (error !== 0) return new Error(msg)
        this.cardNum = data.cardNum
        this.salesSum = data.salesSum
        this.cardRatio = data.cardRatio
        this.price.push(data.price, data.towelprice, data.cardprice, data.carprice)
        this.saleCard.push(data.xianjinCard, data.card99, data.card199, data.card299)
        this.douyinCard.push(data.saleCard, data.cardDouyin99, data.cardDouyin199, data.cardDouyin299)
        this.washcar.push(data.cardType0, data.cardType1)
      } catch (error) {

      }
    },
    getScreen (e, type) {
      if (e) {
        let id = ''
        type === 'business' ? id = this.formData.service_type : type == 'promoter' ? id = this.formData.bid : id = ''
        this.getScreenData(type, id).then(res => {
          if (type === 'module_type') {
            this.typeList = res
          } else if (type === 'business') {
            this.bidList = res
          } else {
            this.promoterList = res
          }
        })
      }
    },
    timeChange (e) {
      if (e) {
        this.formData.startTime = parseInt(e[0] / 1000)
        this.formData.endTime = parseInt(e[1] / 1000)
      } else {
        this.formData.startTime = ''
        this.formData.endTime = ''
      }
    },
    onSubmit () {
      this.getInfo()
    },
  }
}
</script>

<style lang="less" scoped>
.customer {
  height: 100%;
  padding: 24px 32px 0 0;
  box-sizing: border-box;
  .queryBox {
    height: 66px;
    background-color: #fff;
    border-radius: 10px;
    padding-left: 23px;
    display: flex;
    .el-form {
      display: flex;
      align-items: center;
      .el-form-item {
        margin: 0 44px 0 0;
        &:first-child {
          /deep/.el-form-item__content {
            width: 130px;
          }
        }
        &:nth-child(2) {
          /deep/.el-form-item__content {
            width: 130px;
          }
        }
        &:nth-child(3) {
          /deep/.el-form-item__content {
            width: 130px;
          }
        }
      }
    }
  }
  // 图表部分
  .chartBox {
    margin-top: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .publicCss {
      width: 100%;
      background-color: #fff;
      border-radius: 10px;
      padding: 25px 21px;
      box-sizing: border-box;
    }
    .left {
      width: 30%;
      .surveyBox {
        .surveyTitle {
          color: #333333;
          margin-bottom: 50px;
          font-weight: 500;
        }
        .surveyInfo {
          display: flex;
          justify-content: space-around;
          align-items: center;
          .totalBox {
            display: flex;
            align-items: flex-start;
            .totalIcon {
              margin-right: 15px;
              width: 37px;
              height: 37px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .totalDetail {
              color: #333333;
              .TD_title {
                font-size: 14px;
              }
              .TD_num {
                font-size: 40px;
              }
            }
          }
        }
      }
      .genderBox {
        margin-top: 24px;
        .genderTitle {
          color: #333333;
          margin-bottom: 50px;
          font-weight: 500;
        }
      }
    }
    .right {
      width: 68%;
      .totalNum {
        margin-bottom: 24px;
      }
      .totalNum_title,
      .newNum_title {
        color: #333333;
        font-weight: 500;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
